import { MENU_ORDER_MAP } from './constants/menuOrder';

/**
 * Sorts menu items according to predefined order
 * Items not in the predefined order appear at the end
 *
 * @param {Array} menuItems - Array of menu permission objects with menuName property
 * @returns {Array} - Sorted array of menu items
 */
export const sortMenuItemsByOrder = (menuItems) => {
  // Handle edge cases: null, undefined, or empty arrays
  if (!Array.isArray(menuItems) || menuItems.length === 0) {
    return menuItems;
  }

  // Create a new sorted array (non-mutating)
  return [...menuItems].sort((a, b) => {
    const aOrder = MENU_ORDER_MAP[a.menuName];
    const bOrder = MENU_ORDER_MAP[b.menuName];

    // Both items have defined order - sort by their configured position
    if (aOrder !== undefined && bOrder !== undefined) {
      return aOrder - bOrder;
    }

    // Only a has defined order (a comes first)
    if (aOrder !== undefined) return -1;

    // Only b has defined order (b comes first)
    if (bOrder !== undefined) return 1;

    // Neither has defined order - maintain relative position (stable sort)
    return 0;
  });
};
